export default [
    {
        // [0]
        key: "service",
        label: app.$i18n.t("Service"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [1]
        key: "travel",
        label: app.$i18n.t("Travel"),
        visible: true,
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [1]
        key: "status",
        label: app.$i18n.t("Travel status"),
        visible: true,
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [2]
        key: "business_name",
        label: app.$i18n.t("Client"),
        visible: true,
        sortable: true,
    },
    {
        // [2]
        key: "service_type",
        label: app.$i18n.t("Service type"),
        visible: true,
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [3]
        key: "qty_documents",
        label: app.$i18n.t("Documents"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [4]
        key: "quantity",
        label: app.$i18n.t("Quantity"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [5]
        key: "volume",
        label: app.$i18n.t("Volume"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [6]
        key: "weight",
        label: app.$i18n.t("Weight"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [7]
        key: "created_at",
        label: app.$i18n.t("Created At"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        // [5]
        key: "actions",
        label: app.$i18n.t("actions"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
];
